import React from "react";

const ReusableModal = ({ title, content, ButtonValue, onClose, onUpload }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-[20px] shadow-lg max-w-md w-full">
        <h2 className="text-lg font-bold mb-2">{title}</h2>
        <div className="border-b border-1 border-gray-300 mb-4"></div>
        <div className="mb-4">{content}</div>
        <div className=" flex gap-2 w-full justify-center mt-6">
          <button
            onClick={onClose}
            className="border-[1.5px] border-[#035C98] text-gray-700 w-full py-2 rounded-[15px] hover:bg-gray-100 cursor-pointer"
          >
            Cancel
          </button>
          <button
            onClick={() => (onUpload ? onUpload() : () => {})}
            className="border bg-[#035C98] text-white w-full py-2 rounded-[15px] cursor-pointer"
          >
            {ButtonValue}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusableModal;
